import { call, put } from "redux-saga/effects";
import { createSidebarSection, getSidebarSectionList } from "../../../../Services/apiService";
import { createSidebarSectionFailure, createSidebarSectionSuccess, getSidebarSectionListFailure, getSidebarSectionListSuccess } from "../../../Slices/sidebarSlice";

export function* getSidebarSectionListHandler(actions) {
    try {
        const response = yield call(getSidebarSectionList, actions?.payload);
        yield put(getSidebarSectionListSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(getSidebarSectionListFailure(errResponse))
    }
}

export function* createSidebarSectionHandler(actions) {
    try {
        const response = yield call(createSidebarSection, actions?.payload);
        yield put(createSidebarSectionSuccess(response?.data));
    } catch (err) {
        const errResponse = err?.response?.data?.message;
        yield put(createSidebarSectionFailure(errResponse))
    }
}